module.exports = __webpack_public_path__ + "913305344fd127206274f133b7b9ce46.woff2";